<template>
    <article class="a-op-evaluation">
        <div class="a-op-evaluation__date">
            {{ evaluation.period }}
        </div>
        <h3 class="a-op-evaluation__title">
            {{ evaluation.name }}
        </h3>
        <p class="a-op-evaluation__desc">
            {{ evaluation.preview_text }}
        </p>
        <div class="a-op-evaluation__footer">
            <a
                class="a-op-evaluation__link a-arrow-icon"
                :href="evaluation.props.file.src"
                :title="evaluation.props.file.name"
                target="_blank">
                Читать отчёт
            </a>
            <a
                v-if="evaluation.props.href_press_release"
                class="a-op-evaluation__link a-arrow-icon"
                :href="evaluation.props.href_press_release"
                :title="evaluation.props.file.name"
                target="_blank">
                Пресс-релиз
            </a>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'Evaluation',
        props: {
            evaluation: Object
        },
    }
</script>